<template>
  <div class="flex">
    <!---上传excel--->
    <div>
      <el-upload class="upload-demo" :action="this.$api04 + this.urlType" :headers="myHeaders" :on-success="handleAvatarSuccess" :data="type == 'imgS'? data : upLoadData" :show-file-list="false" :file-list="fileList1" :on-exceed="handleExceed" :auto-upload="autoUpload" ref="upload" :on-change="handleChange" :before-upload="beforeAvatarUpload">
        <el-button class="default-btn by-button--default upload_btn" slot="trigger" type="primary">
          <span>{{nameLabel}}</span>
        </el-button>
      </el-upload>
      <template v-for="(item,index) in fileList1">
        <label v-if="!autoUpload" class="file-list" :key="index"> {{item.name}}</label>
      </template>
    </div>
    <!---上传图片--->
    <div>

    </div>
  </div>
</template>

<script>
import { getCookie } from '@/utils/auth'
export default {
  name: 'ByUpload',
  props: {
    exportType: {
      type: String,
      default: "exp"
    },
    //按钮名称
    nameLabel: {
      type: String,
      default: "选择文件"
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    //上传接口类型  默认是上传excel的接口
    urlType: {
      type: String,
      default: '/File/api/FileHandle/UploadFile',
    },
    //上传校验类型   默认excel类型
    extension: {
      type: String,
      default: ' .xls, .xlsx, .csv, '
    },
    //上传类型：图片imgS 默认excel类型
    type: {
      type: String,
      default: '',
    },
    //附件参数
    data: {}
  },
  data() {
    return {
      upLoadData: {
        //UploadType: this.exportType == 'exp' ? 1 :2
        IsTempFile: true
      },
      fileList1: [],
      myHeaders: {
        ['X-JWT-SUPTOKEN']: getCookie("X-JWT-SUPTOKEN")
      },
    }
  },
  computed: {

  },
  created() {
    console.log("=====data参数====", this.data);
  },
  methods: {
    handleAvatarSuccess(file, fileList) {
      debugger
      this.$refs.upload.submit();　//手动上传文件触发按钮
      console.log("g公告====", file);
      this.$emit('handleAvatarSuccess', file, this.fileList1)
    },
    handleExceed(files, fileList) {
      this.$message.warning('上传文件大小不能超过2M')
    },
    //通过 on-change 钩子函数来对列表进行控制
    handleChange(file, fileList) {
      debugger
      this.changeFile = true
      fileList.forEach((item) => {
        if (item.status == 'ready') { //利用返回的状态控制
          this.fileList1 = fileList.slice(-1);
        }
      })
    },
    // 上传前对文件进行的判断
    beforeAvatarUpload(file) {
      debugger
      const extension = this.extension;//' .xls, .xlsx, .csv, '
      var fileName = file.name;
      var ext = fileName.substring(fileName.lastIndexOf('.'), fileName.length) + ", ";
      ext = ext.toLowerCase()

      if (extension.indexOf(ext) == -1) {
        this.$confirm('导入文件只能是：' + extension + '格式!', '提示', {
          customClass: 'custom-message-box', //自定义添加Class
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {
          this.fileList1 = []
        }).catch(() => {

        });
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 10
      const isLtZeroM = file.size / 1024 / 1024 > 0
      if (!isLt2M) {
        this.$confirm('上传文件大小超过10M限制！', '提示', {
          customClass: 'custom-message-box', //自定义添加Class
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {
          this.fileList1 = []
        }).catch(() => {

        });

        return false;
      }
      if (!isLtZeroM) {
        this.$confirm('文件大小为0kb,请重新上传！', '提示', {
          customClass: 'custom-message-box', //自定义添加Class
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {
          this.fileList1 = []
        }).catch(() => {

        });
        return false;
      }


      // this.loading = this.$loading({
      //   lock: true,
      //   text: '正在处理中...',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });

      return true
    },
  }
}
</script>

<style lang="scss" scoped>
.file-list {
  color: #0046b9;
  font-size: 14px;
  margin: 0 8px;
}
.default-btn {
  width: 88px;
  height: 32px;
  background: #ffffff;
  border-radius: 4px;
  line-height: 8px;
  font-size: 13px;
  padding: 0;
  span {
    color: #0046b9;
  }
}
.upload_btn {
  outline: none;
  cursor: pointer;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #dcdcdc;
  transition: background, border 0.2s;
  font-size: 12px;
  font-family: "PingFangSC-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  color: #333333;
  &:hover {
    background: #ffffff !important;
    border: 1px solid rgba(0, 70, 185, 0.4);
    transition: background, border 0.2s;
    color: #0046b9;
  }
  &:active {
    background: #ffffff !important;
    border: 1px solid rgba(0, 70, 185, 0.56);
    transition: background, border 0.2s;
    color: #0046b9;
  }
}
</style>
